import _ from 'lodash';
import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {withFirebase} from 'react-redux-firebase';
import Swal from 'sweetalert2';
import {CircularProgressbarWithChildren, buildStyles} from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

import {
  getUserInfoFromUName, editUserInfo, getPollsCreatedByUname, getFollowing,
  follow, getPollsTakenByUname, uploadPicToS3, logoutUser, getMatchScore, resetErrorAfterPrompt,
} from '../actions';
import LoadingSpinner from 'utils/LoadingSpinner/';
import {
  alertChangeFullName, alertChangeUserName, alertChangeUserBio, alertChangeUserLoc,
} from './SweetAlerts';
// import {profPageBioPH, profPageLocPH} from './placeholders';
import {profPageBioPH, profPageLocPH} from './placeholders';

// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
// @material-ui/icons
import PollIcon from "@material-ui/icons/Poll";
import HistoryIcon from "@material-ui/icons/History";
import FavoriteIcon from "@material-ui/icons/Favorite";
import EditIcon from "@material-ui/icons/Edit";
import PowerIcon from "@material-ui/icons/PowerSettingsNew";
import withWidth, {isWidthDown} from '@material-ui/core/withWidth';

// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import Button from "components/CustomButtons/Button.jsx";
import MUIButton from "@material-ui/core/Button";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import Parallax from "components/Parallax/Parallax.jsx";

import PollGrid from 'components/PollGrid/PollGrid.jsx';
// import CustomizedDialogs from 'components/PollGrid/OnHover.js';


//pics
// import profilePic from "assets/img/faces/christian.jpg";
// import camelDefault from "assets/img/faces/camel.png";
import haroldDefault from "assets/img/faces/harold.jpg";
import ppSqIcon from "assets/img/mscore-icon-final.png";
// import defaultPic from "assets/img/faces/Default-avatar.jpg";

import profilePageStyle from "assets/jss/material-kit-react/views/profilePage.jsx";

class ProfilePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usernameToDisplay: '',
      isThisUserPage: null,
      fakePics: false,
      hasUserPollData: false,
      numPollsCreated: '',
      numPollsTaken: '',
      editNameField: '',
      editUserNameField: '',
      editUserBioField: '',
      editUserLocField: '',
      swalEditUserLoading: false,
      editUserField: '',
      toggleEdit: false,
      matchScore: null,
      isFollowing: null,
      // userNotLoggedIn: true,
    };
  }

  componentWillMount() {
    this.initUserInfo(this.props.match.params.username);
    this.isFollowOrUnfollowButton();
  }

  resetInitState() {
    this.setState({
      numPollsCreated: '',
      numPollsTaken: '',
      isThisUserPage: null,
      hasUserPollData: false,
      isFollowing: null,
      // userNotLoggedIn: true,
    });
  }

  initUserInfo(uname){
    const {profile, getUserInfoFromUName} = this.props;
    const _404Callback = () => this.props.history.push({
      pathname: '/404',
      state: {from: this.props.location.pathname}
    });
    getUserInfoFromUName(uname, _404Callback);
    this.getUserPolls(uname);
    this.setState({usernameToDisplay: uname});

    // if a user is logged in
    if (profile.username) {
      this.props.getFollowing();
      // if user is looking at their own prof page
      if (profile.username === uname) {
        this.setState({isThisUserPage: true});
        // if user is looking at someone else's prof page
      } else {
        this.setState({isThisUserPage: false});
      }
    } else {
      this.setState({
        isThisUserPage: false,
      });
    }
  }

  getUserPolls(uname) {
    const {getPollsTakenByUname, getPollsCreatedByUname} = this.props;
    getPollsTakenByUname(uname);
    getPollsCreatedByUname(uname);
  }

  // NOTE QUESTION added callbacks line 225 editUserInfo() on 4/13/20
  // I can delete this function, right?? delete me later
  // checkNewUserPageToDisplay() {
  //   const {usernameToDisplay} = this.state;
  //   const {username} = this.props.match.params;
  //   if (usernameToDisplay && usernameToDisplay !== username) {
  //     this.resetInitState();
  //     this.initUserInfo(username);
  //     console.log(`updated user from ${usernameToDisplay} to ${username}`);
  //   }
  // }

  componentDidUpdate(prevProps, prevState) {
    // this.checkNewUserPageToDisplay();
    this.checkUpdatedUserInfo(prevProps);
    this.checkGetSetMatchScore(prevProps);
    this.checkUpdatedFollow(prevProps);

    const {hasUserPollData} = this.state;
    const createdInProps = (!_.isEmpty(this.props.poll.created_by));
    const takenInProps = (!_.isEmpty(this.props.poll.taken_by));
    if (!hasUserPollData && createdInProps && takenInProps) {
      this.setState({
        hasUserPollData: true,
        numPollsCreated: this.props.poll.created_by.polls.length,
        numPollsTaken: this.props.poll.taken_by.polls.length,
      });
      // we wanna see the newest polls first
      this.props.poll.created_by.polls.reverse();
      this.props.poll.taken_by.polls.reverse();
    }
  }

  isFollowOrUnfollowButton() {
    const {profile} = this.props;
    const {username} = this.props.match.params;
    const {users} = profile.following;
    // console.log('f or uf called.', users)
    const isUserLoggedInAndHasFollowers = (users && profile && users.following && profile.username);
    // if a user is logged in and we have a list of the users he is following
    if (isUserLoggedInAndHasFollowers && profile.username in users.following) {
      // if the username in the url is being followed by the logged in user
      if (username in users.following[profile.username]) {
        // console.log('isfollowing set .')
        this.setState({isFollowing: true});
      } else {
        // console.log('isfollowing false set .')
        this.setState({isFollowing: false});
      }
    }
  }

  checkUpdatedFollow(prevProps) {
    // console.log('cuf', this.props)
    const {users, last_action, loading_action, loading_get} = this.props.profile.following;
    const hasNewFollowers = (users && !_.isEqual(prevProps.profile.following.users, users));

    if (!loading_get && hasNewFollowers) {
      this.isFollowOrUnfollowButton();
      // console.log('you are following: ', users);
    }
  }

  resetSwalUserInfoState() {
    this.setState({
      swalEditUserLoading: false,
      editUserField: '',
    });
    const _404Callback = () => this.props.history.push({
      pathname: '/404',
      state: {from: this.props.location.pathname}
    });
    // NOTE only call when updated prop has been set with the reducer
    // this.props.getUserInfoFromUName(this.props.profile.username, _404Callback);
  }

  checkGetSetMatchScore(prevProps) {
    const {mscore, mscore_loading, username} = this.props.profile;
    const {isThisUserPage, matchScore} = this.state;

    // check new match score to display
    const hasNewMatchScoreToDisplay = (!_.isEmpty(mscore) &&
      !_.isEqual(mscore, prevProps.profile.mscore));

    // check need to get new matchscore
    const isUserViewDiffPersonsProf = (isThisUserPage !== null &&
      !isThisUserPage && username);
    const shouldGetNewMatchScore = (isUserViewDiffPersonsProf && matchScore === null);

    if (!mscore_loading) {
      if (hasNewMatchScoreToDisplay) {
        this.setState({matchScore: mscore});
        // console.log('match score!! ', mscore);
      } else if (shouldGetNewMatchScore) {
        this.setState({matchScore: ''});
        // console.log('getting new mscore...');
        this.props.getMatchScore(this.props.match.params.username, username);
      }
    }
  }

  checkUpdatedUserInfo(prevProps) {
    const {swalEditUserLoading, editUserField} = this.state;
    const {profile, history, location, match} = this.props;
    if (swalEditUserLoading && editUserField && !profile.loading) {
      const hasUpdatedInfo = (!_.isEmpty(profile.updated));
      if (hasUpdatedInfo) {
        // console.log('getting closer.');
        if (!profile.updated.isEmpty && profile.updated !== prevProps.profile.updated) {
          // console.log('updated...', this.props.profile.updated);
          const newData =  profile.updated.user;
          const _404Callback = () => history.push({
            pathname: '/404',
            state: {from: location.pathname}
          });
          const uname = 'username' in newData ? newData.username : match.params.username;
          this.props.getUserInfoFromUName(uname, _404Callback);
          this.alertAndReset(newData, editUserField);
          // TODO also set state data to match new shit? instead of making another API call??
        }
      }
      // TODO QUESTION above works for first call?
      // need additional check if has actually received new data, not from previous call
    }
  }

  alertAndReset(data, updatedField) {
    // console.log('new data', data, "field, ", updatedField);
    // console.log(`this work?? ${data[updatedField]}`);
    if (updatedField === 'pic_url') {
      Swal('Pic Saved!', 'You have a new profile picture!', 'success');
    } else if (updatedField === 'about') {
        Swal('Saved!', 'Your bio has been updated!', 'success');
    } else {
      Swal('Saved!', `Your new ${updatedField} is ${data[updatedField]}`, 'success');
    }
    // Swal('Saved!', `Your new ${updatedField} is ${data[updatedField]}`, 'success');
    this.resetSwalUserInfoState(); //TODO move this to onClose()
  }

  resetSwalEditTxtFields() {
    this.setState({
      editNameField: '',
      editUserNameField: '',
      editUserBioField: '',
      editUserLocField: '',
    });
  }

  updateUserInfo(newData) {
    const {profile, history, editUserInfo, match} = this.props;
    // NOTE newData is an Object, with what will be changed
    // ie {"username": "SlippyJimmy"} or {"name": "Saul Goodman"}
    // or {"pic_url": 'www.s3.aws.pollpal.com/img.png'}
    // console.log('update u info called');
    // let newUName = profile.username;
    let newUName = match.params.username;
    let newState = {};
    if ('username' in newData) {
      newUName = newData.username;
      newState['usernameToDisplay'] = newUName;
    }
    const pageReloadCB = () => history.push(`/user/${newUName}`);
    const updateDisplayUInfoCB = () => this.setState(newState);
    this.setState({swalEditUserLoading: true, editUserField: _.keys(newData)[0]});
    editUserInfo({newData}, pageReloadCB, updateDisplayUInfoCB);
    this.resetSwalEditTxtFields();
  }

  async alertChangeProfPic() {
    const {classes} = this.props;
    const imageClasses = classNames(
      classes.imgRaised,
      classes.imgRoundedCircle,
      classes.imgFluid,
      classes.imgScale,
    );
    const {value: file} = await Swal.fire({
      title: 'Select new profile pic',
      input: 'file',
      inputAttributes: {
        'accept': 'image/*',
        'aria-label': 'Upload your profile picture'
      },
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: 'Preview',
    });

    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        Swal.fire({
          title: 'Confirm Pic',
          text: 'Like the new you?',
          imageUrl: e.target.result,
          imageAlt: 'new user profile picture',
          imageClass: imageClasses,
          showCancelButton: true,
          reverseButtons: true,
          confirmButtonText: 'Upload',
          // showLoaderOnConfirm: true,
          // allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
          if (result.value) {
            const {uploadPicToS3} = this.props;
            // const done = await uploadPicToS3({img: file, callback: () => this.updatedProfPic()});
            uploadPicToS3({img: file, callback: () => this.updatedProfPic()});
            Swal.fire('Pic Uploaded!', 'Your new profile picture will be refreshed momentarily :)', 'success');
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            Swal.fire('Cancelled', 'We like you just as you are.', 'error');
          }
        });
      };
      reader.readAsDataURL(file);
    }
  }

  // TODO this could work for async swal??
  // async updatedProfPic() {
  updatedProfPic() {
    console.log('prof pic uploaded :)');
    // TODO save the profpic url in the database
    // TODO then load the new pic on the page

    // TODO make send the s3 url in the action???

    this.updateUserInfo({pic_url: this.props.aws.s3imgUrl});
    // const {aws} = this.props;
    // if (!aws.loading) {
    //   if (aws.error) {
    //     Swal.showValidationMessage(`Upload failed: ${aws.error}`);
    //   } else {
    //     return this.props.aws.s3imgUrl;
    //   }
    // }
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.checked });
  };

  renderToggle() {
    const {classes} = this.props;
    if (this.state.isThisUserPage) {
      return (
        <FormControlLabel
          control={
            <Switch
              checked={this.state.toggleEdit}
              onChange={this.handleChange("toggleEdit")}
              value="toggleEdit"
              classes={{
                switchBase: classes.switchBase,
                checked: classes.switchChecked,
                icon: classes.switchIcon,
                iconChecked: classes.switchIconChecked,
                bar: classes.switchBar
              }}
            />
          }
          classes={{
            label: classes.label
          }}
          label="edit"
        />
      );
    }
  }

  logoutCallback() {
    this.setState(
      {isThisUserPage: false},
      () => this.initUserInfo(this.props.match.params.username)
    );
  }

  renderLogoutBtn() {
    const {classes, logoutUser} = this.props;
    if (this.state.isThisUserPage) {
      return (
        <MUIButton
          color="inherit"
          className={classes.signoutBtn}
          onClick={() => logoutUser(() => this.logoutCallback())}
        >
          <PowerIcon className={classes.icons} />
          <p className={classes.signoutTxt}>
            logout
          </p>
        </MUIButton>
      );
    }
  }

  renderPollGrids() {
    const {hasUserPollData, isThisUserPage, toggleEdit} = this.state;
    const {classes} = this.props;
    const {taken_by} = this.props.poll;
    const {created_by} = this.props.poll;
    const editable = (isThisUserPage && toggleEdit);
    // const navImageClasses = classNames(classes.imgRounded, classes.imgGallery);

    // NOTE changed this functionalty 4/18/2019
    // NOTE anyone can see other users poll history??
    // if (hasUserPollData && isThisUserPage) {
    if (hasUserPollData) {
      return (
        <GridContainer justify="center">
          <GridItem xs={12} sm={10} className={classes.navWrapper}>
            <NavPills
              alignCenter
              color="primary"
              tabs={[
                {
                  tabButton: "Created",
                  tabIcon: PollIcon,
                  tabContent: (
                    <PollGrid pollData={created_by.polls} canDelete={editable}/>
                  )
                },
                {
                  tabButton: "Taken",
                  tabIcon: HistoryIcon,
                  tabContent: (
                    <PollGrid pollData={taken_by.polls} canDelete={false}/>
                  )
                },
                {
                  tabButton: "Favorite",
                  tabIcon: FavoriteIcon,
                  tabContent: (
                    <PollGrid pollData={created_by.polls} canDelete={false}/>
                  )
                }
              ]}
            />
          </GridItem>
        </GridContainer>
      );
    } else {
      return (
        // TODO this is quick hack to make spacing look nice, actually do this properly later
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8} className={classes.navWrapper}>
          </GridItem>
        </GridContainer>
      );
    }
  }

  followOnClick = () => {
    const {follow, profile, history} = this.props;
    const uname = this.state.usernameToDisplay.trim();

    if (!profile.username) {
      this.props.resetErrorAfterPrompt();
      alert('You must be logged in to follow someone!!');
      history.push('/user/login');
    } else if (this.state.isFollowing) {
      // if already following, unfollow the user
      follow(uname, false);
    } else {
      // if not already following, user wants to follow
      follow(uname, true);
    }
  }

  renderFollowButton(isVisible=true) {
    const {classes} = this.props;
    const {isFollowing, isThisUserPage} = this.state;
    const btnText = isFollowing ? 'Unfollow' : 'Follow';
    const btnColor = isFollowing ? 'white' : 'primary';
    const btnTxtClass = isFollowing ? classes.followBlueTxt : classes.followTxt;

    if (isThisUserPage) {
      return null;
    }

    const buttonProps = {
      disabled: false,
      variant: "outlined",
      round: true,
      size: "sm",
      color:  btnColor,
      className: classes.followBtn,
      onClick: this.followOnClick,
    }

    if (isWidthDown('sm', this.props.width)) {
      buttonProps.className = '';
    }

    if (!isVisible) {
      buttonProps.className = classes.invFollowBtn;
      buttonProps.disabled = true;
    }

    return <Button {...buttonProps}><p className={btnTxtClass}>{btnText}</p></Button>;
  }

  renderUserInfoIsEditable(_text, _btnId, _onClick) {
    const {isThisUserPage, toggleEdit} = this.state;
    const {classes} = this.props;
    const editable = (isThisUserPage && toggleEdit);

    if (_btnId === "editNameBtn") {
      if (editable) {
        return (
          <h3 className={classes.title}>
            <Button className={classes.invisibleBtn} disabled size="sm" justIcon link><EditIcon/></Button>
              {_text}
            <Button
              id={_btnId}
              onClick={_onClick}
              className={classes.editBtn}
              size="sm"
              justIcon
              link>
              <EditIcon/>
            </Button>
          </h3>
        );
      } else {
        if (isWidthDown('sm', this.props.width)) {
          return (
            <div className={classes.followSectCont}>
              <h3 className={classes.title}>{_text}</h3>
              {this.renderFollowButton()}
            </div>
          );
        } else {
          return (
            <h3 className={classes.title}>
              {this.renderFollowButton(false)}
              {_text}
              {this.renderFollowButton()}
            </h3>
          );
        }
      }
    } else if (_btnId === "editUserNameBtn") {
      if (editable) {
        return (
          <h6>
            <Button className={classes.invisibleBtn} disabled size="sm" justIcon link><EditIcon/></Button>
              {_text}
            <Button
              id={_btnId}
              onClick={_onClick}
              className={classes.editBtn}
              size="sm"
              justIcon
              link>
              <EditIcon/>
            </Button>
          </h6>
        );
      } else {
        return <h6>{_text}</h6>;
      }
    } else if (_btnId === "editLocationBtn") {
      if (editable) {
        return (
          <h5>
            <Button className={classes.invisibleBtn} disabled size="sm" justIcon link><EditIcon/></Button>
              {_text}
            <Button
              id={_btnId}
              onClick={_onClick}
              className={classes.editBtn}
              size="sm"
              justIcon
              link>
              <EditIcon/>
            </Button>
          </h5>
        );
      } else {
        return <h5>{_text}</h5>;
      }
    } else if (_btnId === "editUserBioBtn") {
      if (editable) {
        return (
          <div className={classes.description}>
            <Button
              id={_btnId}
              onClick={_onClick}
              className={classes.editBtn}
              size="sm"
              justIcon
              link>
              <EditIcon/>
            </Button>
            <p>{_text}</p>
          </div>
        );
      } else {
        return (
          <div className={classes.description}>
            <p>{_text}</p>
          </div>
        );
      }
    } else {
      console.log('  ~!~! INVALID BTN ID passed to renderUserFields!!',
        `\n  ~!~!${_btnId} is not a valid option`);
    }
  }

  renderMatchScoreMobile() {
    if (isWidthDown('sm', this.props.width)) {
      return this.renderMatchScore(true);
    }
  }

  renderMatchScoreDesktop() {
    if (!isWidthDown('sm', this.props.width)) {
      return this.renderMatchScore(false);
    }
  }

  renderMatchScore(isMobile) {
    const {matchScore, isThisUserPage} = this.state;
    const {classes} = this.props;
    const {userInfo, name} = this.props.profile;

    if (!isThisUserPage) {
      // mobile/desktop css tweaks
      const container = isMobile ? classes.mscoreMobile : classes.mscoreDivStyle;

      const pbarStyle = buildStyles({
        rotation: 0.75,
        strokeLinecap: 'round',
        // How long animation takes to go from one percentage to another, in seconds
        pathTransitionDuration: 0.5,
        pathColor: '#11b9ba',
        trailColor: 'rgba(174, 209, 59, 0.3)',
      });

      // display match score if logged in
      const msNumber = matchScore ? matchScore.matchScore : 0;
      const msTopTxt = matchScore ? 'Your Match Score' : 'Want a Match Score?';
      const msCenterP = matchScore
        ? <p className={classes.matchScoreNum}>{matchScore.matchScore}</p>
        : <p className={classes.matchScoreNum} style={{letterSpacing: -2}}>n/a</p>;
      const msBottomP = matchScore
        ? <p className={classes.mUnameTxtStyle1}>with {userInfo.name.trim()}</p>
        : <p className={classes.mUnameTxtStyle1}>
            <a href="/user/login">login</a> or <a href="/user/signup">create</a> an account
          </p>;

      return (
        <div className={container}>
          <p className={classes.mTopTxtStyle}>{msTopTxt}</p>
          <div className={classes.progressBarCont}>
            <CircularProgressbarWithChildren value={msNumber} styles={pbarStyle} maxValue={100} strokeWidth={11}>
              <img src={ppSqIcon} className={classes.mscoreBgImg} alt={"pollpals logo"}/>
              {msCenterP}
            </CircularProgressbarWithChildren>
          </div>
          {msBottomP}
        </div>
      );
    }
  }

  renderUserInfoSection() {
    const {numPollsCreated, numPollsTaken, usernameToDisplay, toggleEdit} = this.state;
    const {userInfo} = this.props.profile;
    const {params} = this.props.match;
    const userLocation = _.isEmpty(userInfo.location) ? profPageLocPH : userInfo.location;

    const locSwalParams = {
      locInput: this.state.editUserLocField,
      loading: this.state.swalEditUserLoading,
      updateUserInfoCb: this.updateUserInfo.bind(this),
    };
    const unameSwalParams = {
      unameInput: this.state.editUserNameField,
      loading: this.state.swalEditUserLoading,
      updateUserInfoCb: this.updateUserInfo.bind(this),
    };
    const nameSwalParams = {
      nameInput: this.state.editNameField,
      loading: this.state.swalEditUserLoading,
      updateUserInfoCb: this.updateUserInfo.bind(this),
    };

    return (
      <div className={this.props.classes.name}>
        <div className={this.props.classes.toggleEdit} id="logoutBtn">
          {this.renderLogoutBtn()}
        </div>
        {this.renderMatchScoreMobile()}
        <div className={this.props.classes.toggleEdit} id="edit-toggle">
          {this.renderToggle()}
        </div>
        {this.renderUserInfoIsEditable(
          userInfo.name.trim(), "editNameBtn",
          () => alertChangeFullName(nameSwalParams)
        )}
        {this.renderMatchScoreDesktop()}
        {this.renderUserInfoIsEditable(
          userLocation.trim(), "editLocationBtn",
          () => alertChangeUserLoc(locSwalParams)
        )}
        {this.renderUserInfoIsEditable(
          this.state.usernameToDisplay.trim(), "editUserNameBtn",
          () => alertChangeUserName(unameSwalParams)
        )}
        <h5>{numPollsCreated?`${numPollsCreated} polls created, `:''} {numPollsTaken?`${numPollsTaken} polls taken`:''} </h5>
        {/* <h5> </h5> */}
      </div>
    );
  }

  render() {
    const {isThisUserPage, numPollsTaken, usernameToDisplay, toggleEdit} = this.state;
    const {classes, history, auth, ...rest} = this.props;
    const {userInfo} = this.props.profile;

    if (this.props.profile.loading) {
      return <LoadingSpinner />;
    }
    else if (isThisUserPage == null) {
      return <LoadingSpinner />;
    } else if (_.isEmpty(userInfo)) {
      return <LoadingSpinner />;
    }

    const profPic = userInfo.pic_url ? userInfo.pic_url: haroldDefault;
    const userBio = userInfo.about ? userInfo.about: profPageBioPH;
    const imageClasses = classNames(
      classes.imgRaised,
      classes.imgRoundedCircle,
      classes.imgFluid,
      classes.imgScale,
    );
    const bioSwalParams = {
      bioInput: this.state.editUserBioField,
      loading: this.state.swalEditUserLoading,
      updateUserInfoCb: this.updateUserInfo.bind(this),
    };

    const editable = (isThisUserPage && toggleEdit);

    return (
      <div>
        <Header
          color="transparent"
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{height: 200, color: "white"}}
          {...rest}
        />
        <Parallax small filter image={require("assets/img/profpagebanner.png")} />
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div>
            <div className={classes.container}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={10}>
                  <div className={classes.profile}>
                    <MUIButton
                      className={classes.profPicBtn}
                      color="inherit"
                      onClick={()=>this.alertChangeProfPic()}
                      disabled={!editable}
                    >
                      <img src={profPic} alt={`${usernameToDisplay} profile pic`} className={imageClasses}/>
                    </MUIButton>
                    {this.renderUserInfoSection()}
                  </div>
                </GridItem>
              </GridContainer>
              {this.renderUserInfoIsEditable(
                userBio.trim(), "editUserBioBtn",
                () => alertChangeUserBio(bioSwalParams)
              )}
              {/* <div style={{display: "flex", justifyContent: "center"}}>
                <CustomizedDialogs />
              </div> */}
              {this.renderPollGrids()}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const pageWithStylesAndFirebase = withWidth()(withStyles(profilePageStyle)(withFirebase(ProfilePage)));

function mapStateToProps(state) {
  return {
    auth: state.firebase.auth,
    profile: state.profile,
    poll: state.poll,
    aws: state.aws,
  };
}

// TODO REFACTOR look similar to below
// const mapStateToProps = ({auth, profile, poll, aws}) => {
//   const {user, error, loading} = auth;
//   return {user, error, loading};
// };

export default withRouter(connect(mapStateToProps, {
  getUserInfoFromUName, editUserInfo, getPollsTakenByUname, getFollowing, resetErrorAfterPrompt,
  uploadPicToS3, getPollsCreatedByUname, logoutUser, getMatchScore, follow,
})(pageWithStylesAndFirebase));



// WEBPACK FOOTER //
// ./src/views/ProfilePage.js